import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberProjectsPage from "@/pages/member/MemberProjectsPage";

export const Route = createFileRoute("/member/projects/")({
  head: () => pageHead("Member · Projects", "AKIVA member · projects portal.", "/member/projects", true),
  component: MemberProjectsPage,
});
